import { SxProps, Theme } from '@mui/material';

export const cartStacklayoutMainSX =
	(cantidad: number): SxProps<Theme> =>
	(theme) => ({
		[theme.breakpoints.down('md')]: {
			pb: cantidad === 0 ? '0px' : '77px',
			pt: '0px',
		},
	});
